module.exports = __webpack_public_path__ + "static/media/blended_learning.93bb288a.jpg";